export const PriorityBadge = ({ value }) => {
  const v = String(value || "").toUpperCase();
  const color = {
    BAIXA: "badge-slate",
    MEDIA: "badge-blue",
    ALTA: "badge-amber",
    CRITICA: "badge-red",
  }[v] || "badge-slate";

  return <span className={`badge ${color}`}>{v}</span>;
};
